/* Gift card recipient form.

   Rendered by snippets/gift-card-recipient-form.liquid, and loaded only from
   there, so this never runs on a non-gift-card product.

   Responsibilities:
     - swap the no-JS control flag for the checkbox
     - enable the fields only while the form is open, so a closed form
       contributes no line item properties at all
     - keep the message counter and the timezone offset current

   Every element is looked up inside this custom element, so two instances on
   one page (quick view plus main product, say) cannot collide. */
(function () {
  'use strict';

  if (customElements.get('gift-card-recipient')) return;

  class GiftCardRecipient extends HTMLElement {
    connectedCallback() {
      var id = 'gc-' + (this.dataset.sectionId || '');

      this.checkbox = this.querySelector('#' + CSS.escape(id + '-checkbox'));
      this.fields = this.querySelector('#' + CSS.escape(id + '-fields'));
      this.control = this.querySelector('#' + CSS.escape(id + '-control'));
      this.offset = this.querySelector('#' + CSS.escape(id + '-offset'));
      this.message = this.querySelector('#' + CSS.escape(id + '-message'));
      this.counter = this.querySelector('[data-gc-count]');
      if (!this.checkbox || !this.fields) return;

      this.maxMessage = parseInt(this.dataset.maxMessage, 10) || 200;
      this.countSuffix = this.counter
        ? (this.counter.textContent || '').replace(/^\s*\d+\s*/, '').trim()
        : 'characters remaining';

      /* Hand control to the checkbox. Until this runs, the hidden "if_present"
         input is the one that submits, which is the correct no-JS behaviour. */
      this.checkbox.disabled = false;
      if (this.control) this.control.disabled = true;

      this._onToggle = this._onToggle.bind(this);
      this._onMessageInput = this._onMessageInput.bind(this);

      this.checkbox.addEventListener('change', this._onToggle);
      if (this.message) this.message.addEventListener('input', this._onMessageInput);

      /* A back/forward navigation can restore a ticked checkbox, so sync to
         whatever state the browser handed us rather than assuming closed. */
      this._apply(this.checkbox.checked, false);
      this._onMessageInput();
    }

    disconnectedCallback() {
      if (this.checkbox) this.checkbox.removeEventListener('change', this._onToggle);
      if (this.message) this.message.removeEventListener('input', this._onMessageInput);
    }

    _onToggle() {
      this._apply(this.checkbox.checked, true);
    }

    /* open: show the fields and let them submit. closed: hide and disable, so
       no blank "Recipient name" style rows reach the order. */
    _apply(open, moveFocus) {
      this.fields.hidden = !open;
      this.checkbox.setAttribute('aria-expanded', open ? 'true' : 'false');

      var inputs = this.fields.querySelectorAll('input, textarea, select');
      Array.prototype.forEach.call(inputs, function (el) {
        el.disabled = !open;
      });

      if (open && this.offset) {
        /* Read at open time, not at load: a long-lived page can cross a DST
           boundary, and the value is only meaningful once it is submitted. */
        this.offset.value = String(new Date().getTimezoneOffset());
      }

      if (open && moveFocus) {
        var first = this.fields.querySelector('input:not([type="hidden"]), textarea');
        if (first) {
          try { first.focus({ preventScroll: false }); } catch (e) { first.focus(); }
        }
      }
    }

    _onMessageInput() {
      if (!this.message || !this.counter) return;
      var left = this.maxMessage - this.message.value.length;
      if (left < 0) left = 0;
      this.counter.textContent = left + ' ' + this.countSuffix;
      this.counter.classList.toggle('is-limit', left === 0);
    }
  }

  customElements.define('gift-card-recipient', GiftCardRecipient);
})();
